import React from 'react'

const LOGIN_PATHS = new Set(['/', '/login', '/login/'])

export function isLoginPath(pathname) {
  return LOGIN_PATHS.has(pathname)
}

export function PublicFooter() {
  return (
    <footer className="public-footer">
      <span>杭州型车汽车服务有限公司</span>
      <a href="https://beian.miit.gov.cn/" target="_blank" rel="noreferrer">
        浙ICP备2023011395号-1
      </a>
    </footer>
  )
}
